import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from '../services/settingService/setting.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { borderTopRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';
import { CCCName } from '../services/settingService/setting.enum';
import { F, M } from '@angular/cdk/keycodes';
import { iif } from 'rxjs';
import { PaycheckErrorComponent } from 'src/app/middleware/common/paycheckError/paycheckError.component';

@Component({
  selector: 'app-add-third-party',
  templateUrl: './add-third-party.component.html',
  styleUrls: ['./add-third-party.component.scss']
})

export class AddThirdPartyComponent implements OnInit {

  permissionAsssign: any[] = [];
  rolesAsssign: any[] = [];

  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: number=0;
  payCheck = false;
  menuModulesList:any=[]=[];
  formDialog: FormGroup;
  formDialogupdate: FormGroup;
  formDialogForAPIEndPoint: FormGroup;

  spinner:boolean=false;
  ShowNoRecordFound:boolean=false;
  thirdPartyApplicationList:any=[]=[];
  thirdPartyApiEndpointsList:any=[]=[];
  thirdPartyOfficeApiEndpointsList:any=[]=[];
  thirdPartyApiID:number=0;
  thirdPartyName:string="";
  ShowSuperAdmin:boolean=false;
  thirdPartyEndpointID:number=0;
  selectedThirdPartyOfficeEndpointID:number=0;
  endpointFieldMappings:any=[];
  defaultFieldMappings:any=[];
  mappingFieldsThridParty: any=[];
  FolderId: any;
  FolderName: any;
  MainModuleName: any;
  StepNextButton: boolean;
  Type: number=1;
  Feildproperty:any=[] = []; 
  columnsHeader:any=[] = [];
  columnsNewHeader:any=[] = [];
  currentIndex: any=0;
  addThirdPartyEndpointID:any=0;
  officeThirdpartyApiID: any=0;
  mappingFieldsCore: any=[];
  isFieldChanged:boolean=false;
  mappingFieldsContact: any=[];
  mappingFieldsCompany: any=[];
  officeThirdPartyEndpointFieldMappingID:any=0;
  warningEvent: any;
  warningType: any;
  warningAPiButtonIndex: number;
  DefaultFolderIdDontUSeInAPIcall: any;
  isRequestclientAccessed: any;
  approvalLink: any;
  thirdPartyApiName: any;
  facilitiesList: any;
   constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
    private toastr: ToastrService, private statusConst: StatusConstant, 
    private reusableClass: ReusableClasses, private dialog: MatDialog,
    private encryptionAlgo: EncryptionService, private settingsService: SettingService,
    private constant: Constants,private cdr: ChangeDetectorRef, private coreService: CoreService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
     offices.forEach(oe => {
     this.OfficeIDList.push(oe.officeID);
     if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
     });
   }

  ngOnInit(): void {
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions"));
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){
      var role=[];      
       // roleLevel:1 (Super admin), roleLevel:2 (Organization Admin), roleLevel:3 (Office Admin),
       // roleLevel:11 (User)
      role = this.rolesAsssign.filter((m) => m.roleLevel == 1);
      if(role.length > 0){
         this.ShowSuperAdmin=true;       
       // return;
     } 
    }
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
     this.menuModulesList=  menuModulesList.filter(x => x.mainModuleName == CCCName.Core || x.mainModuleName == CCCName.Contact ||x.mainModuleName == CCCName.Company);
     this.menuModulesList = this.menuModulesList.filter(x => x.isAssign == true);
     this.menuModulesList.forEach(e => {
      if (e.mainModuleName == CCCName.Core) {
        e.isChecked = true;
        this.FolderId=e.folderID;
        this.DefaultFolderIdDontUSeInAPIcall=e.folderID;
        this.FolderName=e.orgModuleName;
        this.MainModuleName= e.mainModuleName;
        this.Type=1;
        this.getFieldForImportExport()
      }
    });
    this.getThirdPartyApplicationList();

  }

 
  GetFacilities(app,templateRef: TemplateRef<any>) {
    this.loaderService.show();   
    var ReqModel = {
      thirdPartyApiID:app.thirdPartyApiID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,      
    }
    this.settingsService.GetFacilities(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.facilitiesList = this.responseHolder.data; 
          if(this.facilitiesList!=null && this.facilitiesList!=undefined)
          {
            this.dialog.open(templateRef, {
              panelClass: 'addThirdParty',
            });
          }        
          this.loaderService.hide();
        }
        else {     
          this.loaderService.hide();
        }
      }
      else {     
        this.loaderService.hide();
      }
    });
  }

  getThirdPartyApplicationList() {
    this.loaderService.show();   
    var ReqModel = {
      isOffice: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,      
    }
    this.settingsService.getThirdPartyApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.thirdPartyApplicationList = this.responseHolder.data;         
          if(this.thirdPartyApplicationList!=null){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.thirdPartyApplicationList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.thirdPartyApplicationList=[];     
        this.loaderService.hide();
      }
    });
  } 

  showDetail(app:any){
    if(app.documentationUrl!=""){
      window.open(app.documentationUrl, "_blank"); 
    }
  }

  showDetailLogo(app:any){
    if(app.apiLogo!=""){
      window.open(app.apiLogo, "_blank"); 
    }
  }

  back(){
    this.thirdPartyApiID= 0;
    this.thirdPartyName="";
    this.payCheck = !this.payCheck;
  }

  selectAPI(event:any){
   // event.value
  }

  authenticateAPiEndPoint(app:any){
    this.thirdPartyApiID= app.thirdPartyApiID;
    this.thirdPartyName=app.thirdPartyApiName;
    this.thirdPartyApiName=app.thirdPartyApiName;
    this.selectedThirdPartyOfficeEndpointID=0;
    this.getThirdPartyApiEndpoints();
    this.officeThirdpartyApiID=app.officeThirdpartyApiID; 
    this.menuModulesList = this.menuModulesList.filter(x => x.isAssign == true);
     this.menuModulesList.forEach(e => {
      if (e.mainModuleName == CCCName.Core) {
        e.isChecked = true;
        this.FolderId=e.folderID;
        this.DefaultFolderIdDontUSeInAPIcall=e.folderID;
        this.FolderName=e.orgModuleName;
        this.MainModuleName= e.mainModuleName;
        this.Type=1;
      }
    });
    this.getOfficeThirdPartyApiEndpoints();
    this.payCheck = !this.payCheck;
    this.mappingFieldsCore=[];
    this.mappingFieldsContact=[];
    this.mappingFieldsCompany=[];
    this.mappingFieldsThridParty=[];
    this.currentIndex=0;
  }

  //==== Sync All Worker Start ======//

  SyncAllWorker(app:any){  
    const message = `This will sync all worker and this process may take more time than the normal operations. 
    Are you sure you want to continue? Please do not press back button once started.`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
        if (dialogResult) {
          this.loaderService.show();   
          this.spinner=true;  
           var ReqModel={
             FolderID:this.FolderId,
             thirdPartyServiceId:app.apiAuthDetail.officeThirdPartyServiceID,
             thirdPartyApiID: app.thirdPartyApiID,
             officeThirdPartyApiID: app.officeThirdpartyApiID,
             userID: this.currentUser.UID,
             organizationID: Number(this.organizationId),
             officeID: this.myOfficeID,  
         }
          this.coreService.SyncAllWorker(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              this.loaderService.hide();
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.spinner=false;          
                this.toastr.success('Data Sync successfully.', '', {
                  timeOut: 3000,
                });
                this.loaderService.hide();        
              }else{        
                this.spinner=false; 
                this.toastr.error(this.responseHolder.message, '', {
                 timeOut: 3000,
               });
                this.loaderService.hide(); 
              }
            }else{      
              this.spinner=false; 
              this.loaderService.hide(); 
            }
          }); 
        }
    });
  }
//==== Sync All Worker End ======//
   //===== For Third Party Application ====== ////

  addNewApplication(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'addThirdParty',
    });
    this.formDialog = this.formBuilder.group({
      applicationName: ['', [Validators.required]],      
      applicationDescription: ['', [Validators.required]],      
      applicationurllogo:['', [Validators.required]],           
      apiDocumentationUrl: ['',[Validators.required]],
      authenticationurl: ['',[Validators.required]],    
    },);   
  }

  updateNewApplication(templateRef: TemplateRef<any>,app:any) {
    this.dialog.open(templateRef, {
      panelClass: 'addThirdParty',
    });
    this.thirdPartyApiID= app.thirdPartyApiID;
    this.formDialog = this.formBuilder.group({
      applicationName: ['', [Validators.required]],      
      applicationDescription: ['', [Validators.required]],      
      applicationurllogo:['', [Validators.required]],           
      apiDocumentationUrl: ['',[Validators.required]],    
      authenticationurl: ['',[Validators.required]],    
    },); 
    this.ImageUploadURL = app.apiLogo;
    this.formDialog.controls.applicationName.setValue(app.thirdPartyApiName);
    this.formDialog.controls.applicationDescription.setValue(app.apiDescription);
    this.formDialog.controls.applicationurllogo.setValue(app.baseUrl);
    this.formDialog.controls.apiDocumentationUrl.setValue(app.documentationUrl); 
    this.formDialog.controls.authenticationurl.setValue(app.apiAuthUrl);
  }      
   

  AddThirdPartyApplication(data) {
    if(this.ImageUploadURL==""){
      this.toastr.warning('Please Upload Logo.', '', {
        timeOut: 3000,
      });
      return;
    }

    let ReqModel = {
     thirdPartyApiID:0,
     apiName: data.applicationName,
     baseUrl: data.applicationurllogo,
     apiAuthUrl:data.authenticationurl,
     documentationUrl: data.apiDocumentationUrl,
     apiLogo: this.ImageUploadURL,
     apiDescription: data.applicationDescription,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),         
     officeID:this.myOfficeID,
   }
   this.loaderService.show();   
   this.spinner=true;  
   this.formDialog.markAsPristine(); 
   this.settingsService.addThirdPartyApi(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;          
         this.toastr.success('3rd party application added successfully.', '', {
           timeOut: 3000,
         });
         this.close();
         this.getThirdPartyApplicationList();
         this.loaderService.hide();        
       }else{        
         this.spinner=false; 
         this.loaderService.hide(); 
       }
     }else{      
       this.spinner=false; 
       this.loaderService.hide(); 
     }
   });
  }

  UpdateThirdPartyApplication(data) {
    if(this.ImageUploadURL==""){
      this.toastr.warning('Please Upload Logo.', '', {
        timeOut: 3000,
      });
      return;
    }

    let ReqModel = {
     thirdPartyApiID:this.thirdPartyApiID,
     apiName: data.applicationName,
     baseUrl: data.applicationurllogo,
     apiAuthUrl:data.authenticationurl,
     documentationUrl: data.apiDocumentationUrl,
     apiLogo: this.ImageUploadURL,
     apiDescription: data.applicationDescription,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),         
     officeID:this.myOfficeID,
   }
   //return;
   this.loaderService.show();   
   this.spinner=true;  
   this.formDialog.markAsPristine(); 
   this.settingsService.addThirdPartyApi(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;          
         this.toastr.success('3rd party application update successfully.', '', {
           timeOut: 3000,
         });
         this.close();
         this.getThirdPartyApplicationList();
         this.loaderService.hide();        
       }else{        
         this.spinner=false; 
         this.loaderService.hide(); 
       }
     }else{      
       this.spinner=false; 
       this.loaderService.hide(); 
     }
   });
  }


  deleteApplication(app: any) {
  var message = `Are you sure you want to delete this 3rd party?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData
  });
  dialogRef.beforeClosed().subscribe(async dialogResult => {
    if (dialogResult) {
      this.loaderService.show();
      var ReqModel={
        thirdPartyAPIId:app.thirdPartyApiID,
        userID: this.currentUser.UID,     
        officeID: this.myOfficeID,
        organizationID: Number(this.organizationId),       
       }
      this.settingsService.DeleteThirdPartyApi(ReqModel).subscribe(response => {
       if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.data == true) {
            this.toastr.success('3rd party application deleted successfully.', '', {
              timeOut: 3000,
            });
            this.getThirdPartyApplicationList();
            this.loaderService.hide();
          }
        }
        else{
          this.loaderService.hide();
        }
      });
    }
  });
  }



   //===== For API End Points ====== ////

  addNewEndPoint(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'addThirdParty',
    });  
    this.formDialogForAPIEndPoint = this.formBuilder.group({
      endpointName: ['', [Validators.required]],      
      endpointUrl: ['', [Validators.required]],      
      method:['', [Validators.required]], 
      requestModel:[''], 
      responseModel:[''],    
    },);   
  } 

  updateAPIEndPoint(templateRef: TemplateRef<any>,app:any) {
    this.dialog.open(templateRef, {
      panelClass: 'addThirdParty',
    });    
    this.formDialogForAPIEndPoint = this.formBuilder.group({
      endpointName: ['', [Validators.required]],      
      endpointUrl: ['', [Validators.required]],      
      method:['', [Validators.required]],
      requestModel:[''], 
      responseModel:[''],      
    },);  

    this.thirdPartyEndpointID =app.thirdPartyEndpointID;
    
    this.formDialogForAPIEndPoint.controls.endpointName.setValue(app.endpointName);
    this.formDialogForAPIEndPoint.controls.endpointUrl.setValue(app.endpointUrl);
    this.formDialogForAPIEndPoint.controls.method.setValue(app.method);  
    this.formDialogForAPIEndPoint.controls.requestModel.setValue(app.requestModel); 
    this.formDialogForAPIEndPoint.controls.responseModel.setValue(app.responseModel);   
  }
  
  addNewOfficeEndPoint(data) {
    if(this.thirdPartyOfficeApiEndpointsList.length>0 && this.thirdPartyOfficeApiEndpointsList.find(m=>m.thirdPartyEndpointID==this.addThirdPartyEndpointID)!=undefined){
      this.toastr.warning('This end point is already added.', '', {
        timeOut: 3000,
      });
      return;
    }
    let ReqModel = {
     thirdPartyApiID: this.thirdPartyApiID,
     thirdPartyEndpointID:this.addThirdPartyEndpointID,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),         
     officeID:this.myOfficeID,
     endpointFieldsMapping: ""
   }  
   this.loaderService.show();   
   this.spinner=true;    
   this.settingsService.AddOfficeThirdPartyApiEndpoint(ReqModel).subscribe(response => {
     if(response != undefined) {
      this.addThirdPartyEndpointID=0;
       this.responseHolder = response;
       this.loaderService.hide();
       if(this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;          
         this.toastr.success('Office api end point added successfully.', '', {
           timeOut: 3000,
         });        
         this.mappingFieldsCore=[];
         this.mappingFieldsContact=[];
         this.mappingFieldsCompany=[];
         this.mappingFieldsThridParty=[];
         this.getOfficeThirdPartyApiEndpoints();
         this.loaderService.hide();        
       }else{        
         this.spinner=false; 
         this.loaderService.hide(); 
       }
     }else{      
       this.spinner=false; 
       this.loaderService.hide(); 
     }
   });
  }


  AddFieldMapping() {
    let ReqModel = {
     thirdPartyApiID: this.thirdPartyApiID,
     thirdPartyEndpointID:this.addThirdPartyEndpointID,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),         
     officeID:this.myOfficeID,
     endpointFieldsMapping: "",
     officeThirdPartyEndpointID: this.selectedThirdPartyOfficeEndpointID,
     officeThirdPartyEndpointFieldMappingID: this.officeThirdPartyEndpointFieldMappingID,
     type:this.Type
   }
   if(this.Type==1){
    let apiFields=this.mappingFieldsCore.filter(m=> m.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
    // Extract allowed field names into an array
    const allowedFieldNames = this.mappingFieldsThridParty.map(field => field.ApiFieldName.toLowerCase());
    
    // Filter apiFields to keep only matching fields
      apiFields = apiFields.filter(field => 
      allowedFieldNames.includes(field.ApiFieldName.toLowerCase())
    );

    ReqModel.endpointFieldsMapping= JSON.stringify(apiFields);
   }
   else if(this.Type==2){
    let apiFields=this.mappingFieldsContact.filter(m=> m.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
    
    // Extract allowed field names into an array
    const allowedFieldNames = this.mappingFieldsContact.map(field => field.ApiFieldName.toLowerCase());
    
    // Filter apiFields to keep only matching fields
      apiFields = apiFields.filter(field => 
      allowedFieldNames.includes(field.ApiFieldName.toLowerCase())
    );

    ReqModel.endpointFieldsMapping=JSON.stringify(apiFields);
   }
   else if(this.Type==3){
    let apiFields=this.mappingFieldsCompany.filter(m=> m.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
    
    // Extract allowed field names into an array
    const allowedFieldNames = this.mappingFieldsCompany.map(field => field.ApiFieldName.toLowerCase());
    
    // Filter apiFields to keep only matching fields
      apiFields = apiFields.filter(field => 
      allowedFieldNames.includes(field.ApiFieldName.toLowerCase())
    );

    ReqModel.endpointFieldsMapping=JSON.stringify(apiFields);
   }  

   let endpointNeedToBeUpdated=this.thirdPartyOfficeApiEndpointsList.find(m=>m.officeThirdPartyEndpointID==this.selectedThirdPartyOfficeEndpointID);
    if(this.thirdPartyApiName=='Paychex')
    {
      var chck=[];
      chck = JSON.parse(ReqModel.endpointFieldsMapping);
      if(chck.length>0){
   
       if(endpointNeedToBeUpdated.endpointName.toLowerCase()!='worker direct deposit' && endpointNeedToBeUpdated.endpointName.toLowerCase()!='update worker direct deposits')
    {
    var checkgivenName=[];
    checkgivenName = chck.filter(x=>x.ApiFieldName.toLowerCase().includes("Given Name".toLowerCase()));
    if(checkgivenName.length==0){
      this.toastr.warning('Select field for Given Name.', '', {
        timeOut: 3000,
      }); 
      return; 
     }
       }
       if(endpointNeedToBeUpdated.endpointName.toLowerCase()!='worker direct deposit' && endpointNeedToBeUpdated.endpointName.toLowerCase()!='update worker direct deposits')
    {
    var checkfamilyName=[];
    checkfamilyName = chck.filter(x=>x.ApiFieldName.toLowerCase().includes("Family Name".toLowerCase()));
    if(checkfamilyName.length==0){
      this.toastr.warning('Select field for Family Name.', '', {
        timeOut: 3000,
      }); 
      return; 
    }
      }
       if(endpointNeedToBeUpdated!=undefined && endpointNeedToBeUpdated.endpointName.toLowerCase()!='update worker' && endpointNeedToBeUpdated.endpointName.toLowerCase()!='worker direct deposit' && endpointNeedToBeUpdated.endpointName.toLowerCase()!='update worker direct deposits')
    {
      var checkworkerType=[];
      checkworkerType = chck.filter(x=>x.ApiFieldName.toLowerCase().includes("Worker Type".toLowerCase()));
      if(checkworkerType.length==0){
        this.toastr.warning('Select field for Worker Type.', '', {
          timeOut: 3000,
        }); 
        return; 
      }
       }	
   
      }
   }

   //return;
   this.loaderService.show();   
   this.spinner=true;    
   this.settingsService.AddOfficeThirdPartyApiEndpoint(ReqModel).subscribe(response => {
     if (response != undefined) {
      this.addThirdPartyEndpointID=0;
      this.isFieldChanged=false;
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;
         this.toastr.success('Field mapping saved successfully.', '', {
           timeOut: 3000,
         });     
         this.mappingFieldsThridParty=[];
         this.mappingFieldsContact=[];
         this.mappingFieldsCompany=[];
         this.mappingFieldsCore=[];
         this.GetOfficeAssociatedApis();
         this.getOfficeThirdPartyApiEndpoints();
         this.loaderService.hide(); 
       }else{        
         this.spinner=false; 
         this.loaderService.hide();
       }
     }else{      
       this.spinner=false;
       this.loaderService.hide();
     }
   });
  }

  AddThirdPartyApiEndpoint(data) {
    let ReqModel = {
     thirdPartyEndpointID:0,
     thirdPartyApiID: this.thirdPartyApiID,
     endpointName: data.endpointName,
     endpointUrl: data.endpointUrl,
     method: data.method,
     requestModel:data.requestModel,
     responseModel:data.responseModel,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),         
     officeID:this.myOfficeID,
   }
   //return;
   this.loaderService.show();
   this.spinner=true;
   this.formDialogForAPIEndPoint.markAsPristine();
   this.settingsService.addThirdPartyApiEndpoint(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;
         this.toastr.success('3rd party api end point added successfully.', '', {
           timeOut: 3000,
         });
         this.closeAPIEndPoint();
         this.getThirdPartyApiEndpoints();
         this.loaderService.hide();
       }else{        
         this.spinner=false;
         this.loaderService.hide();
       }
     }else{      
       this.spinner=false;
       this.loaderService.hide();
     }
   });
  }

  UpdateThirdPartyApiEndpoint(data) {
    let ReqModel = {
     thirdPartyEndpointID: this.thirdPartyEndpointID,
     thirdPartyApiID: this.thirdPartyApiID,
     endpointName: data.endpointName,
     endpointUrl: data.endpointUrl,
     method: data.method,
     requestModel:data.requestModel,
     responseModel:data.responseModel,
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     officeID: this.myOfficeID,
   }
   //return;
   this.loaderService.show();   
   this.spinner=true;
   this.formDialogForAPIEndPoint.markAsPristine(); 
   this.settingsService.addThirdPartyApiEndpoint(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.spinner=false;          
         this.toastr.success('3rd party api end point update successfully.', '', {
           timeOut: 3000,
         });
         this.closeAPIEndPoint();
         this.getThirdPartyApiEndpoints();
         this.loaderService.hide();        
       }else{        
         this.spinner=false; 
         this.loaderService.hide(); 
       }
     }else{      
       this.spinner=false; 
       this.loaderService.hide(); 
     }
   });
  }

  getThirdPartyApiEndpoints() {
    this.loaderService.show();   
    var ReqModel = {
      isOffice: true,
      thirdPartyApiID:this.thirdPartyApiID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,      
    }
    this.settingsService.getThirdPartyApiEndpoints(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.thirdPartyApiEndpointsList = this.responseHolder.data;         
          if(this.thirdPartyApiEndpointsList!=null){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.thirdPartyApiEndpointsList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.thirdPartyApiEndpointsList=[];     
        this.loaderService.hide();
      }
    });
  }

   GetOfficeAssociatedApis() {
    this.loaderService.show();   
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,      
    }
    this.settingsService.GetOfficeAssociatedApis(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          sessionStorage.setItem('associatedAPIs', JSON.stringify(this.responseHolder.data));      
        }
      }
    });
  }
  getOfficeThirdPartyApiEndpoints() {    
    this.loaderService.show();   
    this.spinner=true;  
    var ReqModel = {
      isOffice: true,
      thirdPartyApiID:this.thirdPartyApiID,
      officeThirdPartyApiID:this.officeThirdpartyApiID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,      
    }
    this.settingsService.getOfficeThirdPartyApiEndpoints(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        let str='';
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.thirdPartyOfficeApiEndpointsList = this.responseHolder.data;  
          if(this.thirdPartyOfficeApiEndpointsList.length>0){ 
          if(this.selectedThirdPartyOfficeEndpointID>0){
            str = this.thirdPartyOfficeApiEndpointsList.find(b=>b.officeThirdPartyEndpointID==this.selectedThirdPartyOfficeEndpointID).requestModel;
           // this.selectedThirdPartyOfficeEndpointID=this.thirdPartyOfficeApiEndpointsList[0].officeThirdPartyEndpointID;
            this.endpointFieldMappings=this.thirdPartyOfficeApiEndpointsList.find(b=>b.officeThirdPartyEndpointID==this.selectedThirdPartyOfficeEndpointID).endpointFieldMappings ;
            this.defaultFieldMappings = this.thirdPartyOfficeApiEndpointsList.find(b=>b.officeThirdPartyEndpointID==this.selectedThirdPartyOfficeEndpointID).defaultFieldMappings;
          }else{
          str = this.thirdPartyOfficeApiEndpointsList[0].requestModel;
          this.selectedThirdPartyOfficeEndpointID=this.thirdPartyOfficeApiEndpointsList[0].officeThirdPartyEndpointID;
          this.endpointFieldMappings=this.thirdPartyOfficeApiEndpointsList[0].endpointFieldMappings;
          this.defaultFieldMappings = this.thirdPartyOfficeApiEndpointsList[0].defaultFieldMappings;
          }
          if(this.endpointFieldMappings.length>0){
            if(this.endpointFieldMappings.find(n=>n.type==1)!=undefined)
            {
              let putFiled=JSON.parse(this.endpointFieldMappings.find(n=>n.type==1).fieldJson);
              this.mappingFieldsCore=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.endpointFieldMappings.find(n=>n.type==2)!=undefined)
            {
              let putFiled=JSON.parse(this.endpointFieldMappings.find(n=>n.type==2).fieldJson);
              this.mappingFieldsContact=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.endpointFieldMappings.find(n=>n.type==3)!=undefined)
            {
              let putFiled=JSON.parse(this.endpointFieldMappings.find(n=>n.type==3).fieldJson);
              this.mappingFieldsCompany=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
          }
          else if(this.defaultFieldMappings.length>0)
          {
            if(this.defaultFieldMappings.find(n=>n.type==1)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==1).fieldMappingJson);
              this.mappingFieldsCore=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.defaultFieldMappings.find(n=>n.type==2)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==2).fieldMappingJson);
              this.mappingFieldsContact=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.defaultFieldMappings.find(n=>n.type==3)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==3).fieldMappingJson);
              this.mappingFieldsCompany=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }

          }
          if(this.Type==1)
            {
              this.officeThirdPartyEndpointFieldMappingID= this.endpointFieldMappings.find(n=>n.type==1)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==1).officeThirdPartyEndpointFieldMappingID:0;
            }
           else if(this.Type==2)
            {
              this.officeThirdPartyEndpointFieldMappingID=this.endpointFieldMappings.find(n=>n.type==2)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==2).officeThirdPartyEndpointFieldMappingID:0;
            }
           else if(this.Type==3)
            {
              this.officeThirdPartyEndpointFieldMappingID=this.endpointFieldMappings.find(n=>n.type==3)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==3).officeThirdPartyEndpointFieldMappingID:0;
            }
          let strArray= str.split('#');
              
          strArray.forEach(ev => {
                if(ev.includes('$'))
                {
                  ev=ev.replace("$","");
                    let mapField= {
                      OfficeFieldID:0,
                      OfficeFieldName:"",
                      ApiFieldName:ev,
                      Type:0,
                      ThirdPartyOfficeEndpointID: this.selectedThirdPartyOfficeEndpointID,
                      };
                  this.mappingFieldsThridParty.push(mapField);
                }
              });  
              if(this.Type==1 && this.mappingFieldsCore.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                let selectedField=this.mappingFieldsCore.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID);
                if(selectedField!=undefined)
                {
                   mftp.OfficeFieldID=selectedField.OfficeFieldID;
                   mftp.Type=this.Type;
                 }
                });
              }
             else if(this.Type==2 && this.mappingFieldsContact.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                  let selectedField=this.mappingFieldsContact.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID)
                  if(selectedField!=undefined)
                  {
                     mftp.OfficeFieldID=selectedField.OfficeFieldID;
                     mftp.Type=this.Type;
                  }
                  });
              }
             else if(this.Type==3 && this.mappingFieldsCompany.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                  let selectedField=this.mappingFieldsCompany.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID);
                  if(selectedField!=undefined)
                  {
                     mftp.OfficeFieldID=selectedField.OfficeFieldID;
                     mftp.Type=this.Type;
                  }
                  });
              }
            }
         this.spinner=false; 
         this.loaderService.hide(); 
          if(this.thirdPartyOfficeApiEndpointsList!=null && this.thirdPartyOfficeApiEndpointsList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.thirdPartyOfficeApiEndpointsList=[];      
          this.spinner=false; 
          this.loaderService.hide(); 
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.thirdPartyOfficeApiEndpointsList=[];     
        this.spinner=false; 
        this.loaderService.hide(); 
      }
    });
  }

  getMappingFields(api:any){
    this.selectedThirdPartyOfficeEndpointID=api.officeThirdPartyEndpointID;
    this.refreshFields(api);
  }

  getindex(i:any){
    this.currentIndex=i;
  }
  
  refreshFields(api){ 
    this.isFieldChanged=false;
    this.mappingFieldsThridParty=[];
    this.mappingFieldsContact=[];
    this.mappingFieldsCompany=[];
    this.mappingFieldsCore=[];
    if(api!=undefined)
          {
          this.endpointFieldMappings = api.endpointFieldMappings;
          this.defaultFieldMappings = api.defaultFieldMappings;

          if(this.endpointFieldMappings!=null){
            if(this.endpointFieldMappings.length>0)
            {
              if(this.endpointFieldMappings.find(n=>n.type==1)!=undefined)
              {
                let oldMap=this.mappingFieldsCore;
                this.mappingFieldsCore=JSON.parse(this.endpointFieldMappings.find(n=>n.type==1).fieldJson);
                oldMap.forEach(om => {
                  if(this.mappingFieldsCore.find(m=>
                    m.ApiFieldName==om.ApiFieldName
                    && m.ModuleType==om.ModuleType
                    &&m.OfficeFieldID==om.OfficeFieldID
                    &&m.OfficeFieldName==om.OfficeFieldName
                    &&m.ThirdPartyOfficeEndpointID==om.ThirdPartyOfficeEndpointID
                    )==undefined)
                  {
                    this.mappingFieldsCore.push(om);
                  }
                });
              }
              if(this.endpointFieldMappings.find(n=>n.type==2)!=undefined)
              {
                let oldMap=this.mappingFieldsContact;
                this.mappingFieldsContact=JSON.parse(this.endpointFieldMappings.find(n=>n.type==2).fieldJson);
                oldMap.forEach(om => {
                  if(this.mappingFieldsContact.find(m=>
                    m.ApiFieldName==om.ApiFieldName
                    && m.ModuleType==om.ModuleType
                    &&m.OfficeFieldID==om.OfficeFieldID
                    &&m.OfficeFieldName==om.OfficeFieldName
                    &&m.ThirdPartyOfficeEndpointID==om.ThirdPartyOfficeEndpointID
                    )==undefined)
                  {
                    this.mappingFieldsContact.push(om);
                  }
                });
              }
              if(this.endpointFieldMappings.find(n=>n.type==3)!=undefined)
              {
                let oldMap=this.mappingFieldsCompany;
                this.mappingFieldsCompany=JSON.parse(this.endpointFieldMappings.find(n=>n.type==3).fieldJson);
                oldMap.forEach(om => {
                  if(this.mappingFieldsCompany.find(m=>
                    m.ApiFieldName==om.ApiFieldName
                    && m.ModuleType==om.ModuleType
                    &&m.OfficeFieldID==om.OfficeFieldID
                    &&m.OfficeFieldName==om.OfficeFieldName
                    &&m.ThirdPartyOfficeEndpointID==om.ThirdPartyOfficeEndpointID
                    )==undefined)
                  {
                    this.mappingFieldsCompany.push(om);
                  }
                });
              }
            }            
            if(this.Type==1)
            {
              this.officeThirdPartyEndpointFieldMappingID= this.endpointFieldMappings.find(n=>n.type==1)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==1).officeThirdPartyEndpointFieldMappingID:0;
            }
           else if(this.Type==2)
            {
              this.officeThirdPartyEndpointFieldMappingID=this.endpointFieldMappings.find(n=>n.type==2)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==2).officeThirdPartyEndpointFieldMappingID:0;
            }
           else if(this.Type==3)
            {
              this.officeThirdPartyEndpointFieldMappingID=this.endpointFieldMappings.find(n=>n.type==3)!=undefined?
              this.endpointFieldMappings.find(n=>n.type==3).officeThirdPartyEndpointFieldMappingID:0;
            }

          }
          else
          {
            this.officeThirdPartyEndpointFieldMappingID=0;
          }
                 
         if(this.defaultFieldMappings!=null){
          if(this.defaultFieldMappings.length>0)
          {
            if(this.defaultFieldMappings.find(n=>n.type==1)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==1).fieldMappingJson);
              this.mappingFieldsCore=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.defaultFieldMappings.find(n=>n.type==2)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==2).fieldMappingJson);
              this.mappingFieldsContact=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }
            if(this.defaultFieldMappings.find(n=>n.type==3)!=undefined)
            {
              let putFiled=JSON.parse(this.defaultFieldMappings.find(n=>n.type==3).fieldMappingJson);
              this.mappingFieldsCompany=putFiled.filter(n=>n.ThirdPartyOfficeEndpointID==this.selectedThirdPartyOfficeEndpointID);
            }

          }
         }
          
          let str = api.requestModel; 
          let strArray= str.split('#');
              
          strArray.forEach(ev => {
                if(ev.includes('$'))
                {
                  ev=ev.replace("$","");
                  let mapField= {
                    OfficeFieldID:0,
                    OfficeFieldName:"",
                    ApiFieldName:ev,
                    Type:0,
                    ThirdPartyOfficeEndpointID: this.selectedThirdPartyOfficeEndpointID,
                    }
                  this.mappingFieldsThridParty.push(mapField);
                }
              });  
              if(this.Type==1 && this.mappingFieldsCore.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                let selectedField=this.mappingFieldsCore.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID);
                if(selectedField!=undefined)
                {
                   mftp.OfficeFieldID=selectedField.OfficeFieldID;
                   mftp.Type=this.Type;
                }
                });
              }
             else if(this.Type==2 && this.mappingFieldsContact.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                  let selectedField=this.mappingFieldsContact.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID)
                  if(selectedField!=undefined)
                  {
                     mftp.OfficeFieldID=selectedField.OfficeFieldID;
                     mftp.Type=this.Type;
                  }
                  });
              }
             else if(this.Type==3 && this.mappingFieldsCompany.length>0)
              {
                this.mappingFieldsThridParty.forEach(mftp => {
                  let selectedField=this.mappingFieldsCompany.find(n=>n.ApiFieldName.toLowerCase()==mftp.ApiFieldName.toLowerCase() && n.ThirdPartyOfficeEndpointID==mftp.ThirdPartyOfficeEndpointID);
                  if(selectedField!=undefined)
                  {
                     mftp.OfficeFieldID=selectedField.OfficeFieldID;
                     mftp.Type=this.Type;
                  }
                  });
              }
            }
  }

  CCCSelect(event) { 
    let record=this.menuModulesList.find(e => e.folderID==event.value);
    this.FolderId=record.folderID;
    this.DefaultFolderIdDontUSeInAPIcall=record.folderID
    this.FolderName=record.orgModuleName;
    this.MainModuleName= record.mainModuleName;
    //this.StepNextButton=true;
    let selectedEndPointDetails=this.thirdPartyOfficeApiEndpointsList.find(k=>k.officeThirdPartyEndpointID==this.selectedThirdPartyOfficeEndpointID);
    if(record.mainModuleName==CCCName.Core){
      this.Type=1;
      this.getFieldForImportExport();
      this.refreshFields(selectedEndPointDetails);
    }
    if(record.mainModuleName==CCCName.Contact){
      this.Type=2;
      this.getFieldForImportExport();
      this.refreshFields(selectedEndPointDetails);
    }
    if(record.mainModuleName==CCCName.Company){
      this.Type=3;
      this.getFieldForImportExport();
      this.refreshFields(selectedEndPointDetails);
    }
    this.menuModulesList.forEach(e => {
      e.isChecked = false
    });
    this.menuModulesList.forEach(e => {
      if (e.folderID == record.folderID) {
        e.isChecked = true
      }
    });
  }

  // getSelectedValueOfficeddl(mft)
  // {
  //   if(this.Type==1 && this.mappingFieldsCore.length>0)
  //   {
  //   let selectedField=this.mappingFieldsCore.find(n=>n.ApiFieldName==mft);
  //   if(selectedField!=undefined)
  //   {
  //    return selectedField.OfficeFieldID;
  //   }
  //   }
  //  else if(this.Type==2 && this.mappingFieldsContact.length>0)
  //   {
  //   let selectedField=this.mappingFieldsContact.find(n=>n.ApiFieldName==mft);
  //   if(selectedField!=undefined)
  //   {
  //    return selectedField.OfficeFieldID;
  //   }
  //   }
  //  else if(this.Type==3 && this.mappingFieldsCompany.length>0)
  //   {
  //   let selectedField=this.mappingFieldsCompany.find(n=>n.ApiFieldName==mft);
  //   if(selectedField!=undefined)
  //   {
  //    return selectedField.OfficeFieldID;
  //   }
  //   }
  //   return 0;
  // }
  // type: 1:endpointChanged,2:module changed, 3:going back.
 
 
  fieldLostPopup(templateRef: TemplateRef<any>,type:any,event:any,i:number=1000){
    this.warningEvent=event;
    this.warningType=type;
    this.warningAPiButtonIndex=i;
    if(this.isFieldChanged==true) {
      this.dialog.open(templateRef, {
      });
    }
    else
    {
      this.WaringProceed();
    }
  }

  WaringProceed(){
    if(this.warningType==1)
     this.CCCSelect(this.warningEvent)
    if(this.warningType==2)
    {
    this.getMappingFields(this.warningEvent);
    this.currentIndex=this.warningAPiButtonIndex;
    }
    if(this.warningType==3)
    {
      this.back()
    }
    this.closeFieldLostWarningPopup();
  }

  selectFeildProperty(event:any,mft:any){
      
    this.isFieldChanged=true;
      var CheckData:any;
      CheckData = this.Feildproperty.find(x=> x.fieldID == event.value);     
     let mapField= {
      OfficeFieldID:event.value,
      OfficeFieldName:CheckData!=undefined? CheckData.fieldName:"",
      ApiFieldName:mft.ApiFieldName,
      ModuleType:this.Type,
      ThirdPartyOfficeEndpointID: this.selectedThirdPartyOfficeEndpointID,
      };
      if(this.Type==1)
      {
         if(event.value==0)
        {
          let index = this.mappingFieldsCore.indexOf(this.mappingFieldsCore.find(m=>
            m.ApiFieldName==mapField.ApiFieldName
            && m.ModuleType==mapField.ModuleType
            &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
            ));
          if (index !== -1) {
            this.mappingFieldsCore.splice(index, 1);
          }
          
          return;
        }
        if(this.mappingFieldsCore.find(m=>
          m.ApiFieldName==mapField.ApiFieldName
          && m.ModuleType==mapField.ModuleType
          &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
          )==undefined)
          {
           this.mappingFieldsCore.push(mapField);
          }
          else
          {
            this.mappingFieldsCore = this.mappingFieldsCore.filter(m => {
              // Convert values to lowercase, defaulting to empty string if null/undefined
              const apiFieldNameA = (m.ApiFieldName || '').toLowerCase();
              const apiFieldNameB = (mapField.ApiFieldName || '').toLowerCase();
              const moduleTypeA = (m.ModuleType || '');
              const moduleTypeB = (mapField.ModuleType || '');
            
              // Return true if any of the fields do NOT match
              return (
                apiFieldNameA !== apiFieldNameB || // ApiFieldName does not match
                moduleTypeA !== moduleTypeB || // ModuleType does not match
                m.ThirdPartyOfficeEndpointID !== mapField.ThirdPartyOfficeEndpointID // ThirdPartyOfficeEndpointID does not match
              );
            });
            // if (index !== -1) {
              // this.mappingFieldsCore.splice(index, 1);
            // }
            this.mappingFieldsCore.push(mapField);
          }
      }
      else if(this.Type==2)
      { 
        if(event.value==0)
        {
          let index = this.mappingFieldsContact.indexOf(this.mappingFieldsContact.find(m=>
            m.ApiFieldName==mapField.ApiFieldName
            && m.ModuleType==mapField.ModuleType
            &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
            ));
          if (index !== -1) {
            this.mappingFieldsContact.splice(index, 1);
          }
          return;
        }
        if(this.mappingFieldsContact.find(m=>
          m.ApiFieldName==mapField.ApiFieldName
          && m.ModuleType==mapField.ModuleType
          &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
          )==undefined)
          {
           this.mappingFieldsContact.push(mapField);
          }
          else
          {
            this.mappingFieldsContact = this.mappingFieldsContact.filter(m => {
              // Convert values to lowercase, defaulting to empty string if null/undefined
              const apiFieldNameA = (m.ApiFieldName || '').toLowerCase();
              const apiFieldNameB = (mapField.ApiFieldName || '').toLowerCase();
              const moduleTypeA = (m.ModuleType || '');
              const moduleTypeB = (mapField.ModuleType || '');
                        
              // Return true if any of the fields do NOT match
              return (
                apiFieldNameA !== apiFieldNameB || // ApiFieldName does not match
                moduleTypeA !== moduleTypeB || // ModuleType does not match
                m.ThirdPartyOfficeEndpointID !== mapField.ThirdPartyOfficeEndpointID // ThirdPartyOfficeEndpointID does not match
              );
            });
            this.mappingFieldsContact.push(mapField);
          }
      }
      else if(this.Type==3)
      {
        if(event.value==0)
        {
          let index = this.mappingFieldsCompany.indexOf(this.mappingFieldsCompany.find(m=>
            m.ApiFieldName==mapField.ApiFieldName
            && m.ModuleType==mapField.ModuleType
            &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
            ));
          if (index !== -1) {
            this.mappingFieldsCompany.splice(index, 1);
          }
          return;
        }
        if(this.mappingFieldsCompany.find(m=>
          m.ApiFieldName==mapField.ApiFieldName
          && m.ModuleType==mapField.ModuleType
          &&m.ThirdPartyOfficeEndpointID==mapField.ThirdPartyOfficeEndpointID
          )==undefined)
          {
           this.mappingFieldsCompany.push(mapField);
          }
          else
          {
            this.mappingFieldsCompany = this.mappingFieldsCompany.filter(m => {
              // Convert values to lowercase, defaulting to empty string if null/undefined
              const apiFieldNameA = (m.ApiFieldName || '').toLowerCase();
              const apiFieldNameB = (mapField.ApiFieldName || '').toLowerCase();
              const moduleTypeA = (m.ModuleType || '');
              const moduleTypeB = (mapField.ModuleType || '');
                        
              // Return true if any of the fields do NOT match
              return (
                apiFieldNameA !== apiFieldNameB || // ApiFieldName does not match
                moduleTypeA !== moduleTypeB || // ModuleType does not match
                m.ThirdPartyOfficeEndpointID !== mapField.ThirdPartyOfficeEndpointID // ThirdPartyOfficeEndpointID does not match
              );
            });
            this.mappingFieldsCompany.push(mapField);
          }
      }
  }
   
  
  // GetFieldForApi for Dropdown // 
  getFieldForImportExport() {
    this.loaderService.show();
    var ReqModel = {
      folderID: this.FolderId,
      UserId: this.currentUser.UID,
      OrganizationID:  Number(this.organizationId),      
      officeID: this.myOfficeID,
     }
     this.settingsService.GetFieldForImportExport(ReqModel).subscribe(response => {
     if(response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.Feildproperty = this.responseHolder.data;   
          if(this.Feildproperty && this.Feildproperty.length>0)      
          {
            this.Feildproperty=this.Feildproperty.filter(x=>x.isActiveFieldFolderMapping==true);
          }
          this.Feildproperty= this.Feildproperty.sort((a,b) => a.fieldName.toLowerCase() > b.fieldName.toLowerCase() ? 1 : -1)
          let clear ={
            "fieldID": 0,
            "fieldFolderMappingID": 0,
            "fieldName": "Select",
            "folderID": 0,
            "folderName": null,
            "fieldTypeID": 1,
            "fieldTypeName": "Textbox",
            "position": 1,
            "placeholder": "Select",
            "defaultValue": "",
            "availableOn": 0,
            "isActive": true,
            "isRequired": false,
            "isNonDeactivated": false,
            "fieldCategoryTypeID": 0,
            "charLimit": 0,
            "validation": null,
            "groupModel": null,
            "fieldGroupID": null,
            "subfolderID": 0,
            "groupName": null,
            "isGroupDeleted": false,
            "fieldNames": null,
            "data": null,
            "id": 0,
            "fieldIcon": null,
            "rolePermission": 0,
            "isPrimary": false
        };
         this.Feildproperty= [clear].concat(this.Feildproperty)
          this.loaderService.hide();
        }else{
          this.Feildproperty =[];
          this.loaderService.hide();
        }
      }else{
        this.Feildproperty =[];
        this.loaderService.hide();
      }
    });
  } 

  deleteThirdPartyApiEndpoints(app: any) {
    var message = `Are you sure you want to delete this 3rd party api end point?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel={
          thirdPartyAPIEndpointId:app.thirdPartyEndpointID,
          userID: this.currentUser.UID,     
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),       
         }
        this.settingsService.deleteThirdPartyApiEndpoint(ReqModel).subscribe(response => {
         if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == true) {
              this.toastr.success('3rd party api end point deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getThirdPartyApiEndpoints();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
  }

  deleteThirdPartyOfficeApiEndpoints(app: any) {
  //  return;
    var message = `Are you sure you want to delete this office 3rd party api end point?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel={
          officeThirdPartyEndpointId:app.officeThirdPartyEndpointID,
          userID: this.currentUser.UID,     
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),       
         }
        this.settingsService.deleteOfficeThirdPartyApiEndpoint(ReqModel).subscribe(response => {
         if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == true) {
              this.toastr.success('Office 3rd party api end point deleted successfully.', '', {
                timeOut: 3000,
              });
              this.mappingFieldsThridParty=[];
              this.mappingFieldsContact=[];
              this.mappingFieldsCompany=[];
              this.mappingFieldsCore=[];
              this.getOfficeThirdPartyApiEndpoints();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
  }

    
  closeAuth(){
    this.dialog.closeAll();
    this.loaderService.hide();
  }

  closeAuth1(){
    this.dialog.closeAll();
    this.loaderService.hide();
  }

  closeFieldLostWarningPopup(i:number=0){
    if(i==1){
      this.DefaultFolderIdDontUSeInAPIcall=this.FolderId;
    }
    this.dialog.closeAll();
  }

  close() {
    this.ImageUploadURL="";
    this.formDialog.reset();
    this.dialog.closeAll();
  }
  closeFacilities() {
    this.facilitiesList=[];
    this.dialog.closeAll();
  }

  closeAPIEndPoint() {
    this.ImageUploadURL="";  
    this.formDialogForAPIEndPoint.reset();
    this.dialog.closeAll();
  }
  
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  ImageUploadURL: string="";

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }
  
  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  
  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    var ReqModel={
      UserID : this.currentUser.UID,
      DatabaseID : Number(this.databaseId),
      OrganizationID :  Number(this.organizationId),
      Base64String : this.imageSrc,
      FileName : this.FileName,
      FileExtention : this.FileExtention  
    }   
     this.settingsService.getImageUlpoadURL(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.ImageUploadURL = response.data;          
          }
        }
      });
  }

  officeThirdPartyServiceID:number=0;
  responseHolder1:any;

  getOfficeThirdPartyApis() {
    this.loaderService.show();   
    var ReqModel = {
      officeThirdPartyServiceID:this.officeThirdPartyServiceID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.getOfficeThirdPartyApi(ReqModel).subscribe(response1 => {
      if (response1 != undefined) {
        this.responseHolder1 = response1.data;
        this.granttype = this.responseHolder1.grant_type;
        this.clientId = this.responseHolder1.client_id;
        this.clientsecret = this.responseHolder1.client_secret;
        this.username = this.responseHolder1.username;
        this.password = this.responseHolder1.password;
        this.companyId = this.responseHolder1.companyID;  
        this.displayId= this.responseHolder1.displayID;
        this.facilityID=this.responseHolder1.facilityID;
        //this.isRequestclientAccessed=this.responseHolder1.isRequestclientAccessed;
        this.loaderService.hide();
        this.cdr.detectChanges();
      }
      else {        
      }
    });
  } 

  GetSuperAdminThirdPartyApi() {
    this.loaderService.show();   
    var ReqModel = {
      ThirdPartyApiID:this.thirdPartyApiID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
    }
    this.settingsService.GetSuperAdminThirdPartyApi(ReqModel).subscribe(response1 => {
      if (response1 != undefined) {
        this.responseHolder1 = response1.data;
        this.granttype = this.responseHolder1?.grant_type;
        this.clientId = this.responseHolder1?.client_id;
        this.clientsecret = this.responseHolder1?.client_secret;
        this.username = this.responseHolder1?.username;
        this.password = this.responseHolder1?.password;
        //this.companyId = this.responseHolder1.companyID;      
        this.loaderService.hide();
        this.cdr.detectChanges();
      }
      else {        
      }
    });
  }

  granttype:string="";
  clientId:string="";
  clientsecret:string="";
  username:string="";
  password:string="";
  companyId:string="";
  displayId:string="";
  facilityID:number=0;
  Showauthenticate:boolean=false;
  spinnerauthenticate:boolean=false;

  openDialogWithRef(app,templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
    this.Showauthenticate=false;
    this.spinnerauthenticate=false;
    this.thirdPartyApiID=app.thirdPartyApiID; 
    this.thirdPartyApiName= app.thirdPartyApiName;
    this.granttype="";
    this.clientId="";
    this.clientsecret="";
    this.username="";
    this.password="";   
    this.companyId="";
    this.displayId="";
    this.thirdPartyApiID= app.thirdPartyApiID;
    this.thirdPartyName=app.thirdPartyApiName;
    if(app.apiAuthDetail!=null){
      this.officeThirdPartyServiceID=app.apiAuthDetail.officeThirdPartyServiceID;
      this.getOfficeThirdPartyApis();
    }else{
      this.officeThirdPartyServiceID=0;
    }       
  }

  openSuperDialogWithRef(app,templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
    });
    this.Showauthenticate=false;
    this.spinnerauthenticate=false;
    this.thirdPartyApiID=app.thirdPartyApiID; 
    this.granttype="";
    this.clientId="";
    this.clientsecret="";
    this.username="";
    this.password="";   
    this.companyId="";
    this.displayId="";
    this.thirdPartyApiID= app.thirdPartyApiID;
    this.thirdPartyName=app.thirdPartyApiName;
    this.GetSuperAdminThirdPartyApi();    
  }



  authenticate(templateRef: TemplateRef<any>){
    // if(this.granttype=="" &&  this.clientId=="" && this.clientsecret=="" && this.username=="" && this.password==""){
    //   this.toastr.warning('Please enter details.', '', {
    //     timeOut: 3000,
    //   });
    //   return;
    // } 
    if(this.displayId)
    {
      this.displayId=this.displayId.trim();
    }
    if(this.displayId==""){
      if(this.thirdPartyApiName=='PointClickCare')
      {
      this.toastr.warning('Please enter PointClickCare Organization ID.', '', {
        timeOut: 3000,
      });
      }
      else{
        this.toastr.warning('Please enter display Id.', '', {
          timeOut: 3000,
        });
      }
      return;
    }
    // if(this.granttype!="" || this.clientId!="" || this.clientsecret!=""){
    //   if(this.granttype==""){
    //     this.toastr.warning('Please enter grant type.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    //   if(this.clientId==""){
    //     this.toastr.warning('Please enter client Id.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    //   if(this.clientsecret==""){
    //     this.toastr.warning('Please enter client secret.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }     
    // }

    // if(this.username!="" || this.password!=""){
    //   if(this.username==""){
    //     this.toastr.warning('Please enter username.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    //   if(this.password==""){
    //     this.toastr.warning('Please enter password.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }         
    // }
    // if(this.companyId!=""){
    //   if(this.username==""){
    //     this.toastr.warning('Please enter companyid.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }            
    // }
    // this.payCheck = !this.payCheck;
    let ReqModel = {
      officeThirdPartyServiceID: this.officeThirdPartyServiceID,
      thirdPartyApiID: this.thirdPartyApiID,
      thirdPartyApiName:this.thirdPartyApiName,
      grant_Type: this.granttype,
      client_Id: this.clientId,
      client_Secret: this.clientsecret,
      username: this.username,
      password: this.password,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),  
      officeID: this.myOfficeID,
      companyID: this.companyId,
      displayId:this.displayId,
      facilityID:Number(this.facilityID)
     }
    //return;
    this.loaderService.show();   
    this.spinnerauthenticate=true;
    this.Showauthenticate=true;
    this.settingsService.addOfficeThirdPartyApi(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
         
          //
          if(this.thirdPartyApiName!='PointClickCare')
          {
          this.settingsService.RequestClientAccessPayChex(ReqModel).subscribe(response => {
            if (response != undefined) {
              this.responseHolder = response;
              this.loaderService.hide();
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
               
                this.payCheck = !this.payCheck;
                this.getThirdPartyApiEndpoints();
              
                this.menuModulesList = this.menuModulesList.filter(x => x.isAssign == true);
                this.menuModulesList.forEach(e => {
                 if (e.mainModuleName == CCCName.Core) {
                   e.isChecked = true;
                   this.FolderId=e.folderID;
                   this.DefaultFolderIdDontUSeInAPIcall=e.folderID;
                   this.FolderName=e.orgModuleName;
                   this.MainModuleName= e.mainModuleName;
                   this.Type=1;
                 }
               });
               this.getOfficeThirdPartyApiEndpoints();
               this.dialog.closeAll();
               if(this.responseHolder.data.approvalLink!=null && this.responseHolder.data.approvalLink!=undefined && this.responseHolder.data.approvalLink!='' )
               {
                this.approvalLink=this.responseHolder.data.approvalLink;
                this.dialog.open(templateRef, {
                });
               }
                this.spinnerauthenticate=false;
                this.toastr.success('Approval link generated successfully.', '', {
                  timeOut: 3000,
                });
                this.getThirdPartyApplicationList();
                this.loaderService.hide();        
              }else{   
                if(this.responseHolder.data.errors!=null && this.responseHolder.data.errors!=undefined && this.responseHolder.data.errors.length>0)
                {  
                   this.dialog.closeAll();
                   this.showPaycheckError(this.responseHolder.data.errors);
                }
                
                this.spinnerauthenticate=false; 
                this.loaderService.hide(); 
              }
            }else{      
              this.spinnerauthenticate=false; 
              this.loaderService.hide(); 
            }
          });
        }
        else
        {
          this.dialog.closeAll();
          this.toastr.success('PointClickCare OrganizationId Saved Successfully.', '', {
            timeOut: 3000,
          });
          this.getThirdPartyApplicationList();
        }
          //    
        }else{        
          this.dialog.closeAll();
          this.spinnerauthenticate=false; 
          this.loaderService.hide(); 
        }
      }else{   
        this.dialog.closeAll();   
        this.spinnerauthenticate=false; 
        this.loaderService.hide(); 
      }
    });
   }
   showPaycheckError(error) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {     
      data: {
        list:error,      
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){      
      }      
    });
  } 
   AddEditAPISuperAdmincrendentials(){
    //&& this.username=="" && this.password==""
    if(this.granttype=="" &&  this.clientId=="" && this.clientsecret==""){
      this.toastr.warning('Please enter details.', '', {
        timeOut: 3000,
      });
      return;
    } 

    if(this.granttype!="" || this.clientId!="" || this.clientsecret!=""){
      if(this.granttype==""){
        this.toastr.warning('Please enter grant type.', '', {
          timeOut: 3000,
        });
        return;
      }
      if(this.clientId==""){
        this.toastr.warning('Please enter client Id.', '', {
          timeOut: 3000,
        });
        return;
      }
      if(this.clientsecret==""){
        this.toastr.warning('Please enter client secret.', '', {
          timeOut: 3000,
        });
        return;
      }     
    }

    // if(this.username!="" || this.password!=""){
    //   if(this.username==""){
    //     this.toastr.warning('Please enter username.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }
    //   if(this.password==""){
    //     this.toastr.warning('Please enter password.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }         
    // }
    // if(this.companyId!=""){
    //   if(this.username==""){
    //     this.toastr.warning('Please enter companyid.', '', {
    //       timeOut: 3000,
    //     });
    //     return;
    //   }            
    // }
    // this.payCheck = !this.payCheck;
    let ReqModel = {
      officeThirdPartyServiceID: this.officeThirdPartyServiceID,
      thirdPartyApiID: this.thirdPartyApiID,
      grant_Type: this.granttype,
      client_Id: this.clientId,
      client_Secret: this.clientsecret,
      username: this.username,
      password: this.password,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),  
      officeID: this.myOfficeID,
      companyID: this.companyId,
      displayId:this.displayId
     }
    //return;
    this.loaderService.show();   
    this.spinnerauthenticate=true;
    this.Showauthenticate=true;
    this.settingsService.AddSuperAdminThirdPartyApi(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
         
          this.payCheck = !this.payCheck;
          this.getThirdPartyApiEndpoints();
        
          this.menuModulesList = this.menuModulesList.filter(x => x.isAssign == true);
          this.menuModulesList.forEach(e => {
           if (e.mainModuleName == CCCName.Core) {
             e.isChecked = true;
             this.FolderId=e.folderID;
             this.DefaultFolderIdDontUSeInAPIcall=e.folderID;
             this.FolderName=e.orgModuleName;
             this.MainModuleName= e.mainModuleName;
             this.Type=1;
           }
         });
         this.getOfficeThirdPartyApiEndpoints();
          
          this.spinnerauthenticate=false;
          this.toastr.success('Authenticate successfully.', '', {
            timeOut: 3000,
          });
          this.dialog.closeAll();
          this.getThirdPartyApplicationList();
          this.loaderService.hide();        
        }else{        
          this.spinnerauthenticate=false; 
          this.loaderService.hide(); 
        }
      }else{      
        this.spinnerauthenticate=false; 
        this.loaderService.hide(); 
      }
    });
   }
}
